import React from 'react'
import Link from 'gatsby-link'

//Components
import SelectLanguage from '../components/SelectLanguage'
import SelectLanguageEn from '../components/SelectLanguageEn'
import Modal from '../components/Fleet/FleetModal'

//Icons
import iconYoutube from '../images/icons/youtube-icon.png'
import iconTwiter from '../images/icons/twitter-icon.png'
import iconFacebook from '../images/icons/face-icon.png'

const FooterNav = props => {
  return (
    <nav className="main-nav">
      {props.langs.map(lang => {
        if (lang.langKey == 'en' && lang.selected) {
          return (
            <React.Fragment key={lang.langKey}>
              <div key={lang.langKey} className="grid-wrapper">
                <div>
                  <h3>Reservations</h3>
                  <ul>
                    <li>
                      <a href="/reserve">Rent</a>
                    </li>
                    <li>
                      <a href="/reserve/modify.php">Modify</a>
                    </li>
                    <li>
                      <a href="/reserve/modify.php">Cancel</a>
                    </li>
                    <li>
                      <a href="/en/protections-coverages">Coverages</a>
                    </li>
                   
                  </ul>
                </div>
                <div>
                  <h3>Customer Care</h3>
                  <ul>
                    <li>
                      <Link to={`/${lang.langKey}/faqs`}>FAQS</Link>
                    </li>
                    <li>
                      <Link to={`/${lang.langKey}/suggestions`}>
                        Suggestions
                      </Link>
                    </li>
                   
                  </ul>
                </div>
                <div>
                  <h3>Corporatives</h3>
                  <ul>
                    <li>
                      <Link to={`/${lang.langKey}/corporate_program/`}>
                        Attention to companies
                      </Link>
                    </li>

                     <li>
                      <Link to={`/${lang.langKey}/contact`}>
                        Contact
                      </Link>
                    
                    </li>
                   
                  </ul>
                </div>
                <div>
                  <h3>Contact Us</h3>
                  <ul>
                    <li>
                       <a href="tel:+50522559000" className="phone-footer">
                      +505 2255-9000
                      </a>
                    </li>

                    <li>
                       <a href="tel:+7869559000" className="phone-footer">
                      +786 955-9000
                      </a>
                    </li>

                     <li>
                      <a
                        className="whatsapp-footer"
                        href="https://api.whatsapp.com/send?phone=50588561510"
                      >
                        +505 8856-1510
                      </a>
                    </li>

                    <Modal lang="en" />


                    
                    
                  </ul>
                </div>
              </div>
              <SelectLanguage langs={props.langs} />
              
              
            </React.Fragment>
          )
        } else if (lang.langKey == 'es' && lang.selected) {
          return (
            <React.Fragment key={lang.langKey}>
              <div key={lang.langKey} className="grid-wrapper">
                <div>
                  <h3>Reservaciones</h3>
                  <ul>
                    <li>
                      <a href="/reserve">Renta</a>
                    </li>
                    <li>
                      <a href="/reserve/modify.php">Modificar</a>
                    </li>
                    <li>
                      <a href="/reserve/modify.php">Cancelar </a>
                    </li>
                    <li>
                      <a href="/es/protections-coverages">Coberturas</a> 
                    </li>
                   
                  </ul>
                </div>
                
                <div>
                  <h3>Atención al Cliente</h3>
                  <ul>
                    <li>
                      <Link to={`/${lang.langKey}/faqs`}>FAQS</Link>
                    </li>
                    <li>
                      <Link to={`/${lang.langKey}/suggestions`}>
                        Sugerencias
                      </Link>
                    </li>
                    
                  </ul>
                </div>
                <div>
                  <h3>Corporativo</h3>
                  <ul>
                    <li>
                      <Link to={`/${lang.langKey}/corporate_program`}>
                        Atención a compañias
                      </Link>
                    
                    </li>
                   
                    <li>
                      <Link to={`/${lang.langKey}/contact`}>
                        Contáctenos
                      </Link>
                    
                    </li>
                  </ul>
                </div>
                <div>
                  <h3>Contáctenos</h3>
                  <ul>
                    <li>
                      <a href="tel:+50522559000" className="phone-footer">
                      +505 2255-9000
                      </a>
                    </li>

                    <li>
                       <a href="tel:+7869559000" className="phone-footer">
                      +786 955-9000
                      </a>
                    </li>

                    <li>
                      <a
                        className="whatsapp-footer"
                        href="https://api.whatsapp.com/send?phone=50588561510"
                      >
                        +505 8856-1510
                      </a>
                    </li>
                    <Modal lang="es" />
                   
                  </ul>
                </div>
              </div>
              <SelectLanguageEn langs={props.langs} />
            </React.Fragment>
          )
        }
      })}
    </nav>
  )
}

export default FooterNav



// WEBPACK FOOTER //
// ./src/menus/FooterNav.js